import { useEffect } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import confetti from "canvas-confetti";
import { PartyPopper, X } from "lucide-react";

export function FirstSaleCelebration({ open, onClose, title }) {
  useEffect(() => {
    if (!open) return;
    const colors = ["#d4f253", "#ffffff", "#0f2a33", "#f97316"];
    const end = Date.now() + 1800;
    confetti({ particleCount: 160, spread: 100, origin: { y: 0.55 }, colors, zIndex: 9999 });
    const t = setInterval(() => {
      if (Date.now() > end) return clearInterval(t);
      confetti({ particleCount: 40, angle: 60, spread: 60, origin: { x: 0 }, colors, zIndex: 9999 });
      confetti({ particleCount: 40, angle: 120, spread: 60, origin: { x: 1 }, colors, zIndex: 9999 });
    }, 300);
    return () => clearInterval(t);
  }, [open]);

  if (!open) return null;
  return createPortal(
    <div data-testid="first-sale-celebration" className="fixed inset-0 z-[9000] grid place-items-center bg-[#0f2a33]/85 px-4 backdrop-blur-md">
      <div className="rise relative w-full max-w-md rounded-3xl bg-[#173742] p-8 text-center shadow-2xl">
        <button data-testid="first-sale-close-x" onClick={onClose} className="absolute right-4 top-4 rounded-full p-1.5 text-slate-400 hover:bg-white/10"><X className="h-5 w-5" /></button>
        <div className="mx-auto -rotate-[10deg] inline-block rounded-2xl border-4 border-[#0f2a33] bg-[#d4f253] px-8 py-4 font-display text-5xl font-extrabold text-[#0f2a33] shadow-[0_10px_30px_rgba(0,0,0,0.4)]">ISoldIt!</div>
        <p className="mt-8 flex items-center justify-center gap-2 font-display text-2xl font-bold"><PartyPopper className="h-6 w-6 text-[#d4f253]" />Your first sale!</p>
        <p className="mt-2 text-sm text-slate-300">Congrats on selling <span className="font-semibold text-white">{title}</span>. Got more stuff lying around? It's free to list.</p>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row">
          <Link to="/sell" data-testid="first-sale-sell-again-btn" onClick={onClose} className="btn-lime flex-1 py-3 text-sm">Sell another item</Link>
          <button data-testid="first-sale-close-btn" onClick={onClose} className="flex-1 rounded-xl border border-white/15 py-3 text-sm font-semibold hover:bg-white/5">Done</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
